import { tr } from "@/i18n";
import React from "react";

type State = { error: Error | null };

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Surface to console too
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="error-boundary"
          style={{
            padding: 24,
            color: "#FF5C6C",
            fontFamily: "monospace",
            fontSize: 13,
            whiteSpace: "pre-wrap",
          }}
        >
          <strong>{tr("errorBoundary.title")}</strong>
          {"\n"}
          {this.state.error.message}
          {"\n\n"}
          {(this.state.error.stack || "").split("\n").slice(0, 6).join("\n")}
        </div>
      );
    }
    return this.props.children;
  }
}
